export const Logo = ({ className = "h-16" }) => (
    <a
        href="#home"
        data-testid="logo-link"
        className="flex items-center shrink-0"
        aria-label="ميام – مساحة شفاء ووعي"
    >
        <img
            src="/miamo-clinic-logo.png"
            alt="شعار عيادة ميامو الرسمي"
            data-testid="header-logo"
            className={`${className} w-auto object-contain`}
        />
    </a>
);
